// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Courier from '../components/Courier';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    user: state.auth.user,
    authenticated: state.auth.authenticated,
  };
}

export default connect(mapStateToProps)(Courier);



// WEBPACK FOOTER //
// ./src/modules/courier/containers/CourierContainer.js